import { useTranslation } from "react-i18next";
import imgService from "@/assets/images/perf-service.jpg";
import imgCapability from "@/assets/images/perf-capability.jpg";

export default function PerformanceSection() {
  const { t } = useTranslation();

  const stats = [
    { v: "200+", l: "Managed", dk: "perf.stat1.d" },
    { v: "497", l: "Vessels", dk: "perf.stat2.d" },
    { v: "15,360", l: "Cases", dk: "perf.stat3.d" },
    { v: "991", l: "Onboard", dk: "perf.stat5.d" },
    { v: "93.5%", l: "Remote Fix", dk: "perf.stat4.d" },
  ];

  const performances = [
    {
      tag: "SERVICE",
      titleKey: "perf.card1.title",
      descKey: "perf.card1.desc",
      image: imgService,
      items: ["perf.card1.i1", "perf.card1.i2", "perf.card1.i3", "perf.card1.i4"],
    },
    {
      tag: "CAPABILITY",
      titleKey: "perf.card2.title",
      descKey: "perf.card2.desc",
      image: imgCapability,
      items: ["perf.card2.i1", "perf.card2.i2", "perf.card2.i3", "perf.card2.i4"],
    },
  ];

  return (
    <section id="performance" className="py-4">
      <div>
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wider mb-4">
            <i className="ri-line-chart-line"></i>
            BUSINESS PERFORMANCE
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            {t("perf.heading1")} <span className="text-primary-600">{t("perf.heading2")}</span>
          </h2>
        </div>

        {/* Big stats */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-3">
          {stats.map((s, i) => (
            <div
              key={s.l}
              className={`p-6 md:p-8 rounded-lg ${
                i === 1
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-50 border border-background-200"
              }`}
            >
              <div
                className={`font-heading text-4xl md:text-5xl font-bold mb-2 ${
                  i === 1 ? "text-background-50" : "text-primary-600"
                }`}
              >
                {s.v}
              </div>
              <div
                className={`font-heading font-semibold text-sm tracking-wider uppercase ${
                  i === 1 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {s.l}
              </div>
              <div
                className={`text-xs mt-1 ${
                  i === 1 ? "text-background-100" : "text-foreground-600"
                }`}
              >
                {t(s.dk)}
              </div>
            </div>
          ))}
        </div>
        <p className="text-right text-xs text-foreground-500 mb-8">{t("perf.stats.note")}</p>

        {/* Two cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {performances.map((p) => (
            <a
              key={p.tag}
              href="#contact"
              className="group relative block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-400 transition-all cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={p.image}
                  alt={t(p.titleKey)}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="text-primary-600 text-xs tracking-[0.3em] font-semibold mb-2">
                  {p.tag}
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  {t(p.titleKey)}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base mb-5">
                  {t(p.descKey)}
                </p>
                <ul className="space-y-2 mb-6">
                  {p.items.map((it) => (
                    <li
                      key={it}
                      className="flex items-start gap-2 text-foreground-700 text-sm"
                    >
                      <i className="ri-check-line text-accent-600 mt-0.5"></i>
                      {t(it)}
                    </li>
                  ))}
                </ul>
                <div className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm group-hover:gap-3 transition-all">
                  {t("perf.more")}
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
